import React, { Fragment, useEffect, useState } from "react";
import InnerLayout from "../../../layouts/inner-layout";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate, useLocation } from "react-router-dom";
import SearchAddFeild from "../../../forms/search-add-field";
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { purchaseProductListAction } from "../../../../redux/actions/purchase-action";
import AddButton from "../../../buttons/button";
import DeleteIcon from "../../../../assets/icons/delete-icon";
import {
  alternativeItemsImportAction,
  alternativeItemsListAction,
  deleteAlternativeTransAction,
  mapAlternativerItemAction,
} from "../../../../redux/actions/settings-action";
import successToast from "../../../helper-components/success-toast";
import errorToast from "../../../helper-components/error-toast";
import SortingIcons from "../../../../assets/icons/arrowup-down";
import Pagination from "../../../tables/pagination";
import LoadingSpinner from "../../../helper-components/loading-spinner";
import useCsvUpload from "../../../helper-components/upload-csv-custom-hook";
import LoadingButtonSpinner from "../../../helper-components/loading-button-spinner";
import {
  downloadAllTemplates,
  downloadAllTemplatesJson,
} from "../../../helper-components/helper-function";
import DownloadIcon from "../../../../assets/icons/download-icon";
import excelImg from "../../../../assets/icons/excel.png";
import { FileJson } from "lucide-react";

const AlternativeItemSetup = () => {
  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);

  useEffect(() => {
    const updateHeight = () => {
      const firstDivHeight = document.querySelector(".first-div")?.clientHeight;
      setHeightOfFirstDiv(firstDivHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const location = useLocation();
  const [dataCount, setDataCount] = useState(0);
  const [alternativeItems, setAlternativeItems] = useState([]);
  const [mainLoading, setMainLoading] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);
  const [filterData, setfilterData] = useState({
    sort_order: "",
    sort_by: "",
  });

  const initialValues = {
    item_name: "",
    item_id: "",
    alternative_item_name: "",
    alternative_item_id: "",
  };
  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };
  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      const options =
        data?.data === null
          ? []
          : data.data.map((item) => ({
              value: item.item_id,
              label: item[field],
            }));
      //   .filter(
      //     (option) =>
      //       !values?.data?.some((item) => item?.item_id === option.value)
      //   );
      setLocalData(data.data);
      callback(options);
    };
    const onError = (data) => {};
    if (inputValue?.length > 0) {
      dispatch(
        purchaseProductListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  const validationSchema = Yup.object().shape({
    // cmr_code: Yup.object().required("Customer code number is required"),
    // cmr_name: Yup.object().required("Customer name is required"),
  });

  // Component to track form changes
  const FormChangeTracker = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      const hasChanges =
        JSON.stringify(initialValues) !== JSON.stringify(values);
      console.log("Form change detected:", hasChanges);
      console.log("Initial values:", initialValues);
      console.log("Current values:", values);
      setHasUnsavedChanges(hasChanges);
    }, [values, initialValues]);

    return null;
  };

  // Block navigation when there are unsaved changes
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave?";
        return "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    const handlePopState = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        const shouldNavigate = window.confirm(
          "You have unsaved changes. Are you sure you want to navigate away without saving?"
        );

        if (shouldNavigate) {
          console.log("User confirmed navigation - allowing");
        } else {
          console.log("User cancelled navigation");
          // Push the current state back to prevent navigation
          window.history.pushState(null, "", location.pathname);
        }
        return;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [hasUnsavedChanges, location.pathname]);

  // Override navigate function to check for unsaved changes
  const handleNavigate = (path) => {
    if (hasUnsavedChanges) {
      console.log("Blocking navigation due to unsaved changes");
      const shouldNavigate = window.confirm(
        "You have unsaved changes. Are you sure you want to navigate away without saving?"
      );

      if (shouldNavigate) {
        console.log("User confirmed navigation - allowing");
        navigate(path);
      } else {
        console.log("User cancelled navigation");
      }
      return;
    }
    console.log("Allowing navigation");
    navigate(path);
  };

  const handleSubmit = (values, actions) => {
    if (!values?.alternative_item_id || !values?.item_id)
      return errorToast("Please select both items");
    dispatch(
      mapAlternativerItemAction(
        {
          alternative_item_id: values?.alternative_item_id,
          main_item_id: values?.item_id,
        },
        onSuccess,
        onError
      )
    );
    // Reset form after successful submission
    actions.resetForm();
    setHasUnsavedChanges(false);
  };
  const onSuccessData = (data) => {
    successToast(data?.message);
    setReload(!reload);
  };
  const onError = (data) => {
    errorToast(data?.message);
  };

  useEffect(() => {
    // setMainLoading(true);
    dispatch(
      alternativeItemsListAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
        },
        onFetchSuccess,
        onFetchError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);
  const onFetchSuccess = (data) => {
    setError(false);
    setMainLoading(false);
    setAlternativeItems(data?.data?.itemList ?? []);
    setDataCount(data?.data?.totalCount);
  };
  const onFetchError = (data) => {};

  const tableBodyData = alternativeItems?.map((item) => {
    return {
      main_item_name: item?.main_item_name,
      alternative_item_name: item?.alternative_item_name,
      alternative_id: item?.alternative_id,
    };
  });

  function deleteAltItemFn(id) {
    dispatch(
      deleteAlternativeTransAction(
        {
          alternative_id: id,
        },
        onDeleteSuccess,
        onDeleteError
      )
    );
  }
  const onDeleteSuccess = (data) => {
    successToast(data?.data?.message);
    setReload(!reload);
  };
  const onDeleteError = (data) => {
    errorToast(data?.data?.message);
  };

  const TemplateArray = [
    {
      documentType: "Alternative-item-Setup",
      expectedHeaders: ["alternative_item_id", "main_item_id"],
    },
  ];

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.data?.message);
  };
  const { handleFileUpload, loading } = useCsvUpload(
    alternativeItemsImportAction,
    TemplateArray?.[0]?.expectedHeaders
  );

  return (
    <InnerLayout
      list={true}
      title="Settings"
      module="item-setup"
      // permissionFn={permissionFn}
    >
      {mainLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="my-2  mx-6 h-full">
          <div className="flex justify-between pt-3">
            <div className=" pb-4 flex items-center gap-2 text-sml">
              <button
                className="flex items-center gap-2"
                onClick={() => {
                  handleNavigate("/settings");
                }}
              >
                <ChevronLeftIcon className="h-5 w-5 inline-block" />
                Data Setup Settings /
              </button>
              <span className="cursor-pointer">
                {" " + "Alternative Items Setup"}
              </span>
            </div>
            <div className="flex items-center gap-3 ">
              <div>
                <input
                  type="file"
                  accept=".csv,.json"
                  onChange={(e) => handleFileUpload(e, onSuccess, onError)} // Pass onSuccess and onError functions
                  className="hidden"
                  id="csv-upload"
                />
                <label htmlFor="csv-upload">
                  <div className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700">
                    <img
                      width={20}
                      height={30}
                      src={excelImg}
                      alt="excel-icon"
                    />
                    <FileJson width="20px" height="20px" />
                    {/* {loading ? (
                      <LoadingButtonSpinner className="  h-6 w-6 border-t-2 border-027A48" />
                    ) : ( */}
                    <span>Import CSV / JSON</span>
                    {/* )} */}
                  </div>
                </label>
              </div>
              <span title="Download CSV Template">
                <button
                  type="button"
                  onClick={() => {
                    downloadAllTemplates(TemplateArray);
                  }}
                  className="border-027A48 border-2 rounded-md px-2 py-2"
                >
                  <DownloadIcon fill="var(--success-color)" />
                </button>
              </span>
              <span title="Download JSON Template">
                <button
                  type="button"
                  onClick={() => {
                    downloadAllTemplatesJson(TemplateArray);
                  }}
                  className="border-027A48 border-2 rounded-md px-2 py-2"
                >
                  <DownloadIcon fill="var(--success-color)" />
                </button>
              </span>
            </div>
          </div>
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue }) => {
              return (
                <Form className="h-full w-full">
                  <FormChangeTracker />
                  <div className="flex gap-5 items-center  first-div my-3">
                    <SearchAddFeild
                      border={true}
                      dropdown={true}
                      //   isDisabled={
                      //     values?.data?.length - 1 !== rowIndex || disabled
                      //       ? true
                      //       : false
                      //   }
                      errorClass="hidden"
                      isRequired={false}
                      // value={{
                      //   label: values?.item_name ?? "Search and Select Item..",
                      //   value: "",
                      // }}
                      value={{
                        label: values?.item_name ? (
                          values?.item_name
                        ) : (
                          <p className="text-667085 text-sm">
                            Search and Select Item..
                          </p>
                        ),
                        value: "",
                      }}
                      name={`item_name`}
                      field={`item_name`}
                      isLabelReq={false}
                      defaultSelectClass="border border-D0D5DD rounded-md"
                      placeholder="Search and Select Item.."
                      fetchData={fetchData}
                      onChange={async (selectedOption) => {
                        const filteredData = localData?.find(
                          (item) => item?.item_id === selectedOption?.value
                        );
                        setFieldValue("item_name", filteredData?.item_name);
                        setFieldValue("item_id", filteredData?.item_id);
                        // inputRefs.current?.focus();
                      }}
                      maxLength={30}
                    />
                    <SearchAddFeild
                      maxLength={30}
                      border={true}
                      dropdown={true}
                      //   isDisabled={
                      //     values?.data?.length - 1 !== rowIndex || disabled
                      //       ? true
                      //       : false
                      //   }
                      errorClass="hidden"
                      isRequired={false}
                      value={{
                        label: values?.alternative_item_name ? (
                          values?.alternative_item_name
                        ) : (
                          <p className="text-667085 text-sm">
                            Search and select alternative Item..
                          </p>
                        ),
                        value: "",
                      }}
                      name={`alternative_item_name`}
                      field={`item_name`}
                      isLabelReq={false}
                      defaultSelectClass="border border-D0D5DD rounded-md"
                      placeholder="Search and select alternative Item...."
                      fetchData={fetchData}
                      onChange={async (selectedOption) => {
                        const filteredData = localData?.find(
                          (item) => item?.item_id === selectedOption?.value
                        );
                        setFieldValue(
                          "alternative_item_name",
                          filteredData?.item_name
                        );
                        setFieldValue(
                          "alternative_item_id",
                          filteredData?.item_id
                        );
                      }}
                    />
                    <AddButton
                      className="bg-primary text-white px-8 py-[10px]  rounded-md flex justify-center fw_500 text-sm"
                      prefixIcon={true}
                      text=""
                      type="submit"
                    />
                  </div>

                  <div
                    style={{
                      // minHeight: `calc(100% - ${heightOfFirstDiv}px)`,
                      height: `calc(100% - ${heightOfFirstDiv}px)`,
                    }}
                    className="flex flex-col justify-between"
                  >
                    <div
                      style={{
                        minHeight: `calc(100% - 180px)`,
                        maxHeight: `calc(100% - 180px)`,
                      }}
                      className="overflow-auto rounded-xl table-container border border-gray-200"
                    >
                      <table className=" w-full ">
                        <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                          <tr className="relative h-[50px]">
                            {tableHeading.map((heading, index) => (
                              <th
                                key={index}
                                className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                              >
                                <span
                                  className={`flex items-center gap-2 ${heading?.className}`}
                                >
                                  {heading?.label?.toUpperCase()}
                                  {heading?.display && (
                                    <button
                                    // onClick={() => sortFn(heading?.value)}
                                    >
                                      {" "}
                                      <SortingIcons
                                        inc={
                                          filterData?.sort_order === "ASC" &&
                                          heading?.value === filterData?.sort_by
                                            ? "#475467"
                                            : "#9A9FA6"
                                        }
                                        dec={
                                          filterData?.sort_order === "DESC" &&
                                          heading?.value === filterData?.sort_by
                                            ? "#475467"
                                            : "#9A9FA6"
                                        }
                                      />
                                    </button>
                                  )}
                                </span>
                              </th>
                            ))}
                            <th
                              className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                            >
                              ACTIONS
                            </th>
                          </tr>
                        </thead>
                        <tbody className="h-full">
                          {tableBodyData?.length > 0 ? (
                            <>
                              {tableBodyData.map((rowData, rowIndex) => (
                                <>
                                  <tr
                                    className={`hover:bg-f3f8ff`}
                                    key={rowIndex}
                                  >
                                    <td
                                      className={`text-sm tab-cell  fw_400 text-secondary bg-white`}
                                    >
                                      {rowData?.main_item_name}
                                    </td>
                                    <td
                                      className={`text-sm tab-cell fw_400 text-secondary`}
                                    >
                                      {rowData?.alternative_item_name}
                                    </td>
                                    <td
                                      className={`text-sm tab-cell text-center fw_400 text-secondary bg-white`}
                                    >
                                      <button
                                        type="button"
                                        onClick={() => {
                                          deleteAltItemFn(
                                            rowData?.alternative_id
                                          );
                                        }}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </td>
                                  </tr>
                                </>
                              ))}
                              <tr style={{ height: "10rem" }}></tr>
                            </>
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center py-8">
                                <label
                                  className={` whitespace-nowrap text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                                >
                                  No data available
                                </label>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <Pagination paginationProps={paginationProps} />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      )}
    </InnerLayout>
  );
};

export default AlternativeItemSetup;

// const tablist = ["Item Type", "Item Category", "Item Groups"];

const tableHeading = [
  {
    label: "Main Item Name",
    value: "item_name",
    display: false,
  },
  {
    label: "Alternative Item Name",
    value: "item_name",
    display: false,
  },
  // {
  //   label: "Alternative Item Code",
  //   value: "alternative_item_code",
  //   display: true,
  // },
  // {
  //   label: "Alternative Item Name",
  //   value: "alternative_item_name",
  //   display: true,
  // },
];
